import React from "react";

import { FilePicker, FilePickerProps } from "./FilePicker";
import { TemplatePicker, TemplatePickerProps } from "./TemplatePicker";

type DealContentPickerProps = TemplatePickerProps | FilePickerProps;

export const DealContentPicker: React.FC<DealContentPickerProps> = (props) => {
  if (props.mode === "template") return <TemplatePicker {...props} />;
  return <FilePicker {...props} />;
};
